import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnplug = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "m19 5 3-3" }),
		/* @__PURE__ */ _jsx("path", { d: "m2 22 3-3" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.5 13.5 10 11" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.5 16.5 13 14" }),
		/* @__PURE__ */ _jsx("path", { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z" })
	]
});
const ForwardRef = forwardRef(SvgUnplug);
export default ForwardRef;
